import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStripeRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#635bff",
			fillRule: "evenodd",
			d: "M28.9 16.2c0-1.9-1-3.3-2.6-3.3s-2.8 1.4-2.8 3.3q.1 3.2 3 3.2a4 4 0 0 0 2-.4v-1.5q-.7.4-1.8.4-1.1.1-1.4-1H29zm-3.6-.7q.1-1.2 1-1.2t.9 1.2zm-4.6-2.6a2 2 0 0 0-1.4.5V13h-1.7v8.4l1.8-.4v-2q.4.4 1.3.4c1.3 0 2.5-1 2.5-3.3 0-2-1.2-3.2-2.5-3.2m-.4 5a1 1 0 0 1-.9-.4v-2.7q.3-.3.9-.3 1 .1 1.1 1.7 0 1.6-1.1 1.6m-5.2-5.4 1.9-.3v-1.5l-2 .4z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#635bff",
			d: "M17 13h-2v6.3h2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#635bff",
			fillRule: "evenodd",
			d: "m13.2 13.5-.1-.5h-1.6v6.3h1.8V15q1-.6 1.4-.3V13c-.2 0-1-.2-1.5.5m-3.6-2.1-1.8.4v5.8q.1 1.6 1.9 1.8.9 0 1.3-.2v-1.5c-.3.1-1.4.5-1.4-.6v-2.6H11V13H9.6zm-4.9 3.4q0-.4.6-.4a4 4 0 0 1 1.8.5v-1.7L5.3 13q-2.2 0-2.4 2c0 2 2.7 1.7 2.7 2.6q0 .4-.7.4-1 0-2-.6V19a5 5 0 0 0 2 .4q2.4 0 2.6-2c0-2.1-2.8-1.8-2.8-2.6",
			clipRule: "evenodd"
		})
	]
});
export default SvgStripeRegularIcon;
